import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CallTranscript } from '~/types/CallTranscript'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

import { SectionHeader } from './SectionHeader'

interface InterruptionsSectionProps {
  transcript: CallTranscript
}

const InturruptionsSectionRow = ({
  title,
  count,
  highlight,
}: {
  title: string
  count: number
  highlight?: boolean
}) => {
  const font = highlight ? textStyleKeys.Body2_Bold : textStyleKeys.Body3

  return (
    <Flex
      flexDirection="row"
      backgroundColor={highlight ? 'bg.emphasized' : 'transparent'}
      justifyContent="flex-start"
      borderRadius="0.75rem"
      paddingLeft="0.75rem"
      paddingRight="0.75rem"
    >
      <Text {...textStyles[font]} width="50%">
        {title}
      </Text>
      <Text {...textStyles[font]}>{count}</Text>
    </Flex>
  )
}

export const InterruptionsSection = ({
  transcript,
}: InterruptionsSectionProps) => {
  const { t } = useTranslation()
  const totalInterruptions =
    transcript.ConversationCharacteristics.Interruptions.TotalCount

  const agentInterruptions =
    transcript.ConversationCharacteristics.Interruptions
      .InterruptionsByInterrupter.AGENT?.length ?? 0

  const customerInterruptions =
    transcript.ConversationCharacteristics.Interruptions
      .InterruptionsByInterrupter.CUSTOMER?.length ?? 0

  return (
    <Flex
      flexDirection="column"
      width="100%"
      gap="0.875rem"
      flex="1 0 100%"
      height="7.125rem"
    >
      <SectionHeader
        title={t('callDetails.sections.interruptions.title')}
        tooltipText={t('callDetails.sections.interruptions.tooltip')}
      />
      <Flex
        flexDirection="column"
        justifyContent="center"
        flex="1 0 0"
        gap="0.5rem"
      >
        <InturruptionsSectionRow
          title={t('callDetails.sections.interruptions.total')}
          count={totalInterruptions}
          highlight
        />
        <InturruptionsSectionRow
          title={t('callDetails.sections.interruptions.patient')}
          count={customerInterruptions}
        />
        <InturruptionsSectionRow
          title={t('callDetails.sections.interruptions.office')}
          count={agentInterruptions}
        />
      </Flex>
    </Flex>
  )
}
